<template>
<section class="draft-page-wrapper">
  <section class="draft-page-inner-wrapper">

    <div class="draft-data" v-if="draft">
      <div class="text-center m-b-50">
        <a target="_blank" :href="draft.store ? draft.store.siteUrl : ''"><img :src="draft.store ? draft.store.logoImageUrl : ''" alt="" width="260"></a>
      </div>
  
      <p>This page is best viewed in Google Chrome, Mozilla Firefox and Safari Browser.</p>
  
      <b-alert show variant="info" v-if="!hasLinkExpired">
          <strong>Important Info:</strong> If you request changes, it might delay the delivery of the order. 
          <span v-if="draft" class="for-dev">This link will expire in {{ moment(draft.draftRevisionDateTimeLimit).format('DD-MM-YYYY, h:mm a') }}</span>
      </b-alert>
      <b-alert show variant="danger" v-if="hasLinkExpired"><strong>Important Info:</strong> You can no longer ask for changes in the artwork because {{timeLimit}}  hours have already passed since we sent you this page URL in your email address.</b-alert>

      <h2 class="hide-in-mobile">
        Order no :  <span class="orderNo">
              {{ draft.store &&  draft.store.orderPrefixArray.length > 0 ? draft.store.orderPrefixArray[0] : ''}}{{ !isEmpty(draft) && draft.customerInfo.orderNo }}
            </span>
      </h2>

      <a href="" @click.prevent="orderDetails = !orderDetails">Click to Show Order related info</a>
      <section class="order-details m-b-30 m-t-20 " ref="orderDetails" v-show="orderDetails">
        
        <b-row class="m-b-10">
          <b-col md="3" class="headings"><strong>First name :</strong></b-col>
          <b-col md="8">{{ !isEmpty(draft) && draft.customerInfo.firstName }}</b-col>
        </b-row>
        <b-row class="m-b-10">
          <b-col md="3" class="headings"><strong>Last name :</strong></b-col>
          <b-col md="8">{{ !isEmpty(draft) && draft.customerInfo.lastName }}</b-col>
        </b-row>
        <b-row class="m-b-10">
          <b-col md="3" class="headings"><strong>Email :</strong></b-col>
          <b-col md="8">{{ !isEmpty(draft) && draft.customerInfo.email }}</b-col>
        </b-row>
        <b-row class="m-b-10">
          <b-col md="3" class="headings"><strong>Timezone :</strong></b-col>
          <b-col md="8">{{ timezone }}</b-col>
        </b-row>
        <b-row class="m-b-10">
          <b-col md="3" class="headings"><strong>IP address :</strong></b-col>
          <b-col md="8">{{ userIp }}</b-col>
        </b-row>
      </section>
  
      <h3 class="p-t-20">
        {{ draft ? draft.DraftFiles.length : 0 }} Artworks below:
      </h3>
      <p><strong>Note:</strong> We request you to respond on all artworks</p>
  
      <section >
        <single-draft-file v-for="(draftFile, index) in draft.DraftFiles" :key="index" :draft="draftFile" :ip="userIp" :timezone="timezone" :has-link-expired="hasLinkExpired" :draft-type="draft.draftType" :response-complete-on-all="customerRespondedOnAllFiles" :feedback-received="draft.DraftFeedback ? true : false"/>
      </section>

      <draft-feedback v-if="!draft.DraftFeedback && customerRespondedOnAllFiles" :hash-code="$route.params.hashCode"/>
      <b-row v-else-if="draft.DraftFeedback && customerRespondedOnAllFiles" class="receivedFeedbackBox">
         <b-col sm="5">
           <img src="https://sellerdawn.s3.amazonaws.com/Code-Chunks/2021-01-04/2021-01-04_09-50-21-feedback.png" alt="" class="img-fluid">
         </b-col>
         <b-col sm="7">
           <h3>We received your feedback</h3>
           <h4>Thank you for taking the time to rate our work and giving your valuable feedback.</h4>
           <p>It helps us immensely to improve our work.</p>
         </b-col>
      </b-row>

      
      
      <footer class="draftViewFooter">
        <div v-if="draft.store && draft.store.supportEmail">
          For any queries or support, contact us at : <span>{{  draft.store.supportEmail }}</span>
        </div>
      </footer>
      
    </div>
    <div class="text-center" v-else>
      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>

    <div v-if="draft && draft.customerRespondedOnDraftLinkAt">
      <draft-response-completion-indicator :files="draft.DraftFiles"/>
    </div>

    

  </section>

  
  
</section>
</template> 

<script>
const SingleDraftFile = () => import( /* webpackChunkName: "single-draft-file" */ "./single-draft-file")
import CustomerDraftService from '../../../services/customer-drafts.service';
const DraftResponseCompletionIndicator = () => import(/* webpackChunkName: "draft-response-completion-indicator" */ "./draft-response-completion-indicator")
const DraftFeedback = () => import(/* webpackChunkName: "draft-feedback" */ "../feedback/draft-feedback")


import _ from 'lodash';
import * as moment from 'moment-timezone';
import axios from 'axios'
import EventBus from '../../../EventBus'
export default {
  data() {
    return {
      draft: null,
      bgPatthern: require('@/assets/images/patterns/y-so-serious.png'),
      userIp: '',
      orderDetails: false,
      timeLimit: 48
    }
  },
  components: {
    SingleDraftFile,
    DraftResponseCompletionIndicator,
    DraftFeedback,
  },
  mounted() {

    window.onbeforeunload = this.PopUpExit;

    function PopUpExit() {
        return "You want to leave this page?";
    }
    

    window.addEventListener('contextmenu', function (e) {
      // do something here... 
      e.preventDefault();
    }, false);

    document.body.style.background = `url('${this.bgPatthern}')`;

    this.getDataOnPageLoad()
    EventBus.$on('customer-responded-on-draft', () => {
      this.fetchSingleDraftDetails(this.$route.params.hashCode, 'no', this.timezone, '')
    })

    EventBus.$on('draft-feedback-given-by-customer', () => {
      this.fetchSingleDraftDetails(this.$route.params.hashCode, 'no', this.timezone, '')
    })

    

  },
  methods: {
     
    async fetchSingleDraftDetails(draftPageHash, saveAccessTime = 'no', timezone = "unknown", ip = "") {
      const draftDetails = await CustomerDraftService.fetchSingleDraftDetails(draftPageHash, saveAccessTime, timezone, ip);

      this.draft = draftDetails.data.draft
    },

    isEmpty(obj) {
      return _.isEmpty(obj)
    },
    async getDataOnPageLoad() {
      try {
        const ip = await axios.get('https://api.ipify.org?format=json')
        this.userIp = ip.data.ip;

        this.fetchSingleDraftDetails(this.$route.params.hashCode, 'yes', this.timezone, ip.data.ip);

      } catch (e) {
        this.fetchSingleDraftDetails(this.$route.params.hashCode, 'yes', this.timezone, "");
      }
    }
  },
  computed: {
    timezone() {
      return moment.tz.guess();
    },

    hasLinkExpired() {
      var now = moment().utc();
      var expiry = this.draft ? moment(this.draft.draftRevisionDateTimeLimit).utc() : null;

      if (now > expiry) {
        return true;
      } else {
        return false
      }

    },
    customerRespondedOnAllFiles(){
       let responded = true;

       this.draft.DraftFiles.forEach(file => {
          if(!['Yes', 'No'].includes(file.approvalStatus)){
             responded = false;
          }
       })

       return responded;
    }
  

  },
  beforeDestroy: function(){
    EventBus.$off('customer-responded-on-draft')
    EventBus.$off('draft-feedback-given-by-customer')
  }
}
</script>

<style lang="scss" scoped>
.draft-page-wrapper {
  max-width: 960px;
  margin: 30px auto;
  margin-bottom: 100px;
}

.draft-page-inner-wrapper {
  background-color: #fff;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1), -2px -2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px 25px;
  border-radius: 5px;
  border-top: 5px solid rgb(37, 124, 255);
  border-bottom: 5px solid rgb(72, 82, 97);
  min-height: calc(100vh - 60px);
  margin: 0 30px;
}

.draftViewFooter {
  border-top: 1px dashed rgb(179, 179, 179);
  padding-top: 25px;
  margin-top: 50px;
}

.order-details {
  background: #eff2f5;
  /* fallback for old browsers */
  color: #484e53;
  border-radius: 5px;
  padding: 20px;
  border: 2px solid #e5eaf0;
}

.orderNo {
  background-color: rgb(38, 132, 255);
  display: inline-block;
  padding: 5px 10px;
  color: #fff;
  border-radius: 5px;
}
.headings{
  text-align: right;
}
@media only screen and (max-width: 767px){
  .headings{
    text-align: left;
  }
  .hide-in-mobile{
    display: none;
  }
  .draft-page-inner-wrapper{
    margin: 0;
  }
  .draft-page-wrapper {
    margin-top: 0;
  }
}
.receivedFeedbackBox{
 box-shadow: 0 -2px 4px rgba(0, 0, 0, .1), 0 8px 16px rgba(0, 0, 0, .1);
 padding: 30px;
 border-radius: 10px;
 h3{
   margin-top: 50px;
   color: #785CAD;
 }
 h4{
   margin-top: 20px;
   line-height: 28px;
 }
}
.for-dev{
  display: none;
}
</style>
